import Vue from 'vue'
import Vuex from 'vuex'
import { alert } from './store/alert.module';
import { users } from './store/users.module';
import { keyValues } from './store/keyValues.module';
import { nomatim } from './store/nomatim.module';
import { staticInfos } from './store/staticInfos.module';
import { occurences } from './store/occurences.module';
import { startInfos } from './store/startInfos.module';
import { comments } from './store/comments.module';
import { pointMovements } from './store/pointMovements.module';
import { sessions } from './store/sessions.module';
import { voteMovements } from './store/voteMovements.module';

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  namespaced: true,
  state,
  mutations,
  modules: {alert,users,keyValues,nomatim,staticInfos,occurences,startInfos,comments,pointMovements, sessions, voteMovements}
});